const initialState = {
  site: process.env.REACT_APP_HOSTNAME || window.location.hostname,
  features: {},
  reports: [],
  analytics: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_THEME':
      return { ...state, ...action.payload };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
